import React from "react";

import SipPage from "../SipPage";
import { hotelsMeta, hotels } from "../variables";

const Hotels: React.FC = () => <SipPage meta={hotelsMeta} section={hotels} />;

export default Hotels;
